import React, { useEffect, useState } from 'react';
import type { PresentationSignal } from '../../lib/presentation/afterPresentation';
import {
  isEmbedPath,
  onAfterPresentation,
  presentationSignal,
} from '../../lib/presentation/afterPresentation';
import { useAfterPresentation } from '../../hooks/useAfterPresentation';

interface StageTwoGateProps {
  children: React.ReactNode;
}

/**
 * Segura o stage two até o primeiro paint ter chance de acontecer.
 *
 * Só é aplicado nas rotas de embed. Nas outras rotas os filhos aparecem no
 * primeiro efeito, sem esperar a barreira, para que o comportamento e o ciclo
 * de vida continuem iguais aos de antes.
 *
 * O primeiro render devolve null no cliente e no servidor, então a hidratação
 * é idêntica à do SSR e não abre espaço para React #418/#423.
 */
function StageTwoGate({ children }: StageTwoGateProps) {
  const [embed, setEmbed] = useState<boolean | null>(null);
  const presented = useAfterPresentation(embed === true);

  useEffect(() => {
    setEmbed(isEmbedPath(window.location.pathname));
  }, []);

  useEffect(() => {
    if (embed !== true || !presented) return;
    const signal: PresentationSignal | null = presentationSignal();
    if (typeof window !== 'undefined') {
      (window as unknown as { stageTwoSignal?: string }).stageTwoSignal =
        signal ?? 'unknown';
    }
  }, [embed, presented]);

  if (embed === false) return children as React.ReactElement;
  if (embed === true && presented) return children as React.ReactElement;
  return null;
}

export { onAfterPresentation };
export default StageTwoGate;
